import React, { useState, useEffect } from 'react';
import { useAuth } from '../utils/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';
import AIChatSupport from './AIChatSupport';

const ChatToggleButton = () => {
  const { user } = useAuth();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    if (!user) return;

    const checkUserRole = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const userData = userDoc.data();
        const role = userData?.role;
        
        // Only show chat for hosts, venues, and admins
        if (['host', 'venue', 'admin'].includes(role)) {
          setIsAuthorized(true);
        }
      } catch (error) {
        console.error('Error checking user role:', error);
      }
    };

    checkUserRole();
  }, [user]);

  if (!isAuthorized) return null;

  return (
    <>
      {/* Chat Toggle Button */}
      <button
        onClick={() => setIsChatOpen(!isChatOpen)}
        className="fixed bottom-4 right-4 w-14 h-14 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-200 z-40"
        title="AI Support Chat"
      >
        {isChatOpen ? (
          <span className="text-xl">✕</span>
        ) : (
          <span className="text-xl">💬</span>
        )}
      </button>

      {/* AI Chat Support Component */}
      <AIChatSupport 
        isOpen={isChatOpen} 
        onClose={() => setIsChatOpen(false)} 
      />
    </>
  );
};

export default ChatToggleButton; 